/**
 * @generated SignedSource<<a1a8deaaeb807af773bf06fc7d7ab099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentDeleteInput = {
  id: string;
};
export type CommentMutationActionItem_commentDeleteMutation$variables = {
  input: CommentDeleteInput;
};
export type CommentMutationActionItem_commentDeleteMutation$data = {
  readonly commentDelete: {
    readonly id: string;
  };
};
export type CommentMutationActionItem_commentDeleteMutation = {
  response: CommentMutationActionItem_commentDeleteMutation$data;
  variables: CommentMutationActionItem_commentDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentMutationActionItem_commentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "commentDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentMutationActionItem_commentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "commentDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8243b93f6626177f010a6d2bf9f5241",
    "id": null,
    "metadata": {},
    "name": "CommentMutationActionItem_commentDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CommentMutationActionItem_commentDeleteMutation(\n  $input: CommentDeleteInput!\n) {\n  commentDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc1c08c9b93c6c41082273a1b79440c2";

export default node;
